import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 24px;
  align-items: center;
  flex-direction: row;
`;

export const PrevButton = styled.button`
  transform: rotate(180deg);
  appearance: none;
  border: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

export const Month = styled.p`
  flex: 1;
  text-align: center;
  font-size: 16px;
  margin: 0;
`;

export const NextButton = styled.button`
  appearance: none;
  border: none;
  outline: none;
  background-color: transparent;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;
